import { render, staticRenderFns } from "./TenantNotificationSetting.vue?vue&type=template&id=2ef198a7&"
import script from "./TenantNotificationSetting.vue?vue&type=script&lang=js&"
export * from "./TenantNotificationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports